import { buildSchema, buildProperty } from "@camberi/firecms";

/**
 * This is a schema that is generated without passing an explicit type,
 * but it is inferred correctly since we are using `buildProperty` in each property
 */
export const fitnessLevelSchema = buildSchema({
    name: "Fitness Level",
    properties: {
        title: buildProperty({
            title: "Title",
            validation: { required: true },
            dataType: "string"
        }),
        fitnessLevelName: buildProperty({
            title: "Fitness Level Name",
            validation: { required: true },
            dataType: "string"
        }),
        description: buildProperty({
            title: "Description",
            validation: { required: true },
            dataType: "string"
        }),
        order: {
            title: "Order",
            dataType: "number",
            validation: { required: true },
        },
        status: {
            title: "status",
            dataType: "boolean"
        },
        createdAt: buildProperty({
            title: "Created At",
            dataType: "timestamp",
            validation: { required: true },
        }),
        UpdatedAt: buildProperty({
            title: "Updated At",
            dataType: "timestamp",
            validation: { required: true },
        }),
    },
    defaultValues: {
        status: false,
        order: 0
    }
});

